/**
 * Подсчёт прогресса пазла: totalPieces, число правильно поставленных деталей,
 * текст для отображения (X/Y), проверка «пазл собран» и однократный вызов onCompleted.
 * Сцена только получает getText() и подписывается на onCompleted.
 */
export type PuzzleProgressOptions = {
  /** Вызывается один раз, когда placedCorrect впервые становится равным total (и total > 0). */
  onCompleted: () => void;
};

export class PuzzleProgress {
  private totalPieces = 0;
  private placedCorrectCount = 0;
  private completionShown = false;
  private onCompleted: () => void;

  constructor(options: PuzzleProgressOptions) {
    this.onCompleted = options.onCompleted;
  }

  /**
   * Обновить состояние прогресса. Если placedCorrect === total && total > 0 и завершение ещё не показывали —
   * один раз вызывается onCompleted и помечаем, что показали.
   */
  update(total: number, placedCorrect: number): void {
    this.totalPieces = total;
    this.placedCorrectCount = placedCorrect;
    if (
      this.totalPieces > 0 &&
      this.placedCorrectCount === this.totalPieces &&
      !this.completionShown
    ) {
      this.completionShown = true;
      this.onCompleted();
    }
  }

  /** Строка для отображения в DOM (например в .puzzle-progress): "placed/total". */
  getText(): string {
    return `${this.placedCorrectCount}/${this.totalPieces}`;
  }

  /** Сброс при смене/уничтожении пазла (новый пазл не должен считать завершение уже показанным). */
  reset(): void {
    this.totalPieces = 0;
    this.placedCorrectCount = 0;
    this.completionShown = false;
  }
}
